import React, { type FunctionComponent, type ReactElement } from 'react';

import constants from '#packages/constants';
import { workspace } from '#packages/util';
import { UndoButtonTooltip } from './undoTooltip/undoTooltip';
import withCustomDropPanelBehavior from '../../hocs/withCustomDropPanelBehavior';
import { TextLabel } from '@wix/wix-base-ui';

import TopBarButtonWithTooltip from '../../topBarButton/topBarButtonWithTooltip';
import TopBarButtonWithPopover from '../../topBarButton/topBarButtonWithPopover';

interface UndoButtonProps {
  tooltip?: ReactElement;
  disabled?: boolean;
  onClick: () => void;
  onMouseLeave?: () => void;
  onMouseEnter?: () => void;
  interactive?: boolean;
  tooltipMaxWidth?: number;
}

const UndoButton: FunctionComponent<UndoButtonProps> = (props) => {
  const symbolName = workspace.isNewWorkspaceEnabled()
    ? 'undo_NewWorkspace'
    : 'undo2_v2';

  return props.disabled ? (
    <TopBarButtonWithPopover
      className="top-bar-button-undo"
      automationId="top-bar-button-undo"
      symbolName={symbolName}
      disabled={props.disabled}
      tooltip={<UndoButtonTooltip />}
      interactive={true}
      onClick={props.onClick}
      onMouseLeave={props.onMouseLeave}
      onMouseEnter={props.onMouseEnter}
    />
  ) : (
    <TopBarButtonWithTooltip
      className="top-bar-button-undo"
      automationId="top-bar-button-undo"
      symbolName={symbolName}
      disabled={props.disabled}
      tooltip={
        <TextLabel
          dataHook="top-bar-undo-button-tooltip"
          value="TOPBAR_UNDO_TOOLTIP_TITLE"
          enableEllipsis={false}
        />
      }
      interactive={false}
      onClick={props.onClick}
      onMouseLeave={props.onMouseLeave}
      onMouseEnter={props.onMouseEnter}
    />
  );
};

const ConnectedUndoButton = withCustomDropPanelBehavior(
  constants.ROOT_COMPS.TOPBAR.BUTTONS.UNDO,
)(UndoButton) as React.ComponentType<UndoButtonProps>;

export default ConnectedUndoButton;
